import type { InferOutput } from 'valibot'
import { array, check, intersect, literal, maxLength, maxValue, minLength, minValue, nullish, number, object, optional, pipe, regex, string, transform, trim, union } from 'valibot'
import { containsSuspiciousPatterns, validateFlParameter, validateQfParameter } from './query-utils'

export const defTypeSchema = union([
  literal('edismax'),
  literal('dismax'),
  literal('lucene'),
])

export const paramsSchema = object({
  q: optional(string(), '*:*'),
  defType: optional(defTypeSchema, 'edismax'),
  fq: nullish(union([string(), pipe(array(string()), minLength(1))])),
  fl: nullish(pipe(
    string(),
    transform(value => validateFlParameter(value)),
  )),
  qf: nullish(pipe(
    string(),
    transform(value => validateQfParameter(value)),
  )),
  pf: nullish(pipe(
    string(),
    transform(value => validateQfParameter(value)),
  )),
  pf2: nullish(pipe(
    string(),
    transform(value => validateQfParameter(value)),
  )),
  pf3: nullish(pipe(
    string(),
    transform(value => validateQfParameter(value)),
  )),
})

export const requestParamsSchema = intersect([
  paramsSchema,
  object({
    rows: nullish(pipe(
      number(),
      minValue(0),
      maxValue(10000),
    )),
    start: nullish(pipe(
      number(),
      minValue(0),
    )),
  }),
])

export const responseParamsSchema = intersect([
  paramsSchema,
  object({
    rows: nullish(string()),
  }),
])

export const searchLiteratureParamsSchema = object({
  searchTerm: optional(pipe(
    string(),
    trim(),
    maxLength(200),
  )),
  id: optional(string()),
  contentType: optional(array(string())), // f.ex. ['book', 'academicArticle', 'chapter', 'page']
})

export type SearchLiteratureParams = InferOutput<typeof searchLiteratureParamsSchema>

export const searchLawAndLawCommentaryParamsSchema = object({
  lawId: optional(pipe(
    string(),
    trim(),
    maxLength(150),
    regex(/^[\w-]+$/, 'Invalid law ID format'),
    check(val => !containsSuspiciousPatterns(val), 'Malicious law ID detected'),
  )),
  commentId: optional(pipe(
    number(),
    minValue(1, 'Comment ID must be a positive number'),
    maxValue(100000, 'Comment ID too large'),
  )),
  searchTerm: optional(pipe(
    string(),
    trim(),
    maxLength(200),
  )),
})

export type SearchLawAndLawCommentaryParams = InferOutput<typeof searchLawAndLawCommentaryParamsSchema>

export const newestDocsParamsSchema = object({
  rows: optional(pipe(
    number(),
    minValue(1),
    maxValue(100),
  ), 4),
  start: optional(pipe(
    number(),
    minValue(0),
  ), 0),
  contentType: nullish(string()),
})

export type NewestDocsParams = InferOutput<typeof newestDocsParamsSchema>
